class BslHtml {
    constructor() {

    }

    lock() {
		  document.documentElement.classList.add('no-scroll');
		  document.body.classList.add('no-scroll');
    }

    unlock() {
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
    }

    static get() {
        if (BslHtml.instance === undefined) BslHtml.instance = new this()
        return BslHtml.instance
    }
}